const mapping: Record<string, string> = {
  id: 'i=>i.Id',
}

export const mapSortPrintItemParametersParam = (key: string) => mapping[key]
